<template>
  <div class="dashboard-switch-wrapper d-flex align-items-center justify-content-center position-relative">
    <div v-if="getLoaders.aiTemplate || getLoaders.aiBuddy" class="disabled-overlay" />
    <ib-tooltip :content="`${$t('tooltipToggleStatus')}`">
      <!--    <v-app>-->
      <v-switch
        v-model="value"
        color="success"
        :label="`${value ? $t('completed') : $t('inProgress')}`"
        hide-details
        :disabled="!canEdit || getLoaders.aiTemplate || getLoaders.aiBuddy"
        :class="`${value ? 'completed' : 'inProgress'}`"
      />
    <!--    </v-app>-->
    </ib-tooltip>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventBus from '@/event-bus'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'StepStatusSwitch',

  mixins: [MixinIdeaRoles],

  props: {
    stepName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      value: false
    }
  },

  computed: {
    ...mapGetters('ui', ['getLoaders']),

    statusOfCompleted () {
      return this.$store.state.idea.storyMode.common.completedSteps[this.stepName]
    }
  },

  watch: {
    statusOfCompleted (value) {
      if (!this.canEdit) return
      this.value = value
    },

    value () {
      if (!this.canEdit) return
      EventBus.$emit('change-step-status', this.value)
    }
  },

  created () {
    this.value = this.statusOfCompleted
  },

  mounted () {
    EventBus.$on('return-step-in-progress', () => {
      this.value = false
    })
  },

  beforeDestroy () {
    EventBus.$off('return-step-in-progress')
  },

  methods: {
    ...mapActions('idea', ['completeStep'])
  }
}
</script>

<style scoped lang="scss">
.dashboard-switch-wrapper {
  margin-left: 15px !important;

  @include media-breakpoint-up($lg) {
    margin-left: 25px !important;
  }
  ::v-deep {
    label {
      font-family: $outfit-regular;
      display: none !important;

      @include media-breakpoint-up($md) {
        display: flex !important;
      }
    }
  }
}

.disabled-overlay {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
}

//.completed {
//  ::v-deep {
//    label {
//      opacity: 1;
//    }
//  }
//}

.inProgress {
  ::v-deep {
    label {
      color: $color-text-light-gray;
    }
  }
}
</style>
